
<script>
  export let project
  import Tech from "./Tech.svelte";
</script>
<div style="margin:5px">
  {#if project.url}
    <div>
      {#if project.iconUrl}
        <img src={project.iconUrl} style="height:32px"/>
      {/if}
      <a href={project.url}>{project.name}</a>
      <span>{" " + project.description}</span>
    </div>
  {:else}
    <span>{project.name}</span>
  {/if}
  {#if project.stack}
  <div style="display:flex">
    <span style="display: flex; align-items: center;" class="has-text-weight-medium">Technologies:</span>
  {#each project.stack as tech}
    <Tech {tech}/>
  {/each}
  </div>
  {/if}
  {#if project.roles}
  <div style="display:flex">
    <span style="display: flex; align-items: center;" class="has-text-weight-medium">Roles:&nbsp;</span>
  {#each project.roles as role}
    <span>{role} &nbsp;</span>
  {/each}
  </div>
  {/if}
</div>
